import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Shield } from 'lucide-react'

/**
 * Footer Component
 * Consistent footer for all pages with Jonkai Ventures branding
 */
const Footer = () => {
  const navigate = useNavigate()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 py-12 border-t border-gray-800">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center space-y-6">
          {/* Logo and Brand Name */}
          <div className="flex flex-col items-center space-y-4">
            <div className="flex items-center space-x-3">
              <Shield className="w-8 h-8 text-orange-500" />
              <span className="text-2xl font-bold bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text text-transparent">
                SurviveIt
              </span>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-base">
            <button
              onClick={() => navigate('/')}
              className="text-gray-400 hover:text-orange-400 transition bg-transparent border-none cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => navigate('/emergency')}
              className="text-gray-400 hover:text-orange-400 transition bg-transparent border-none cursor-pointer"
            >
              Emergency Mode
            </button>
            <button
              onClick={() => navigate('/personality-quiz')}
              className="text-gray-400 hover:text-orange-400 transition bg-transparent border-none cursor-pointer"
            >
              Survival Quiz
            </button>
            <button
              onClick={() => navigate('/auth')}
              className="text-gray-400 hover:text-orange-400 transition bg-transparent border-none cursor-pointer"
            >
              Sign Up
            </button>
          </div>

          {/* Copyright */}
          <div className="text-gray-400 text-base">
            &copy; {currentYear} SurviveIt by Jonkai Ventures. All rights reserved.
          </div>

          {/* Tagline */}
          <div className="text-gray-500 text-sm">
            Interactive survival training platform for families
          </div>

          {/* Company Information */}
          <div className="pt-4 space-y-2">
            <div className="text-gray-400 text-base font-semibold">
              SurviveIt is a brand of:
            </div>
            <div className="text-gray-400 text-base">
              Jonkai Ventures OÜ
            </div>
            <div className="text-gray-500 text-sm">
              Tartu mnt 67/1-13b, 10115 - Harju maakond, Tallinn, Kesklinna linnaosa
            </div>
            <div className="text-gray-500 text-sm">
              Registrikood 17322110 - Estonia EU
            </div>
            <div className="text-gray-400 text-base">
              <a
                href="mailto:info@surviveitapp.com"
                className="hover:text-orange-400 transition"
              >
                info@surviveitapp.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
